import Http from 'services/Http';

class Invite {
  async send(employeeId, forceChannel) {
    const body = forceChannel ? { forceChannel } : null;
    const { data } = await Http.post(`/v1/employee/${employeeId}/invite/sms`, body);
    return data;
  }

  /** Public check — returns { company } for a valid invite token. */
  async check(inviteToken) {
    const { data } = await Http.get(`/v1/invite/${encodeURIComponent(inviteToken)}`);
    return data;
  }
}

export default new Invite();
